import React, { ComponentProps, useMemo } from 'react';
import { compose } from 'recompose';
import { default as Form } from '../../components/connectedForm';
import { EdataConfig as entity } from '../../graphql/entities';
import createForm from '../../components/connectedForm/ConnectedForm';
import * as input from '../../components/connectedForm/inputComponents';
import { IEdataConfig } from '../../graphql/schema/p4types';
import * as withContainer from '../../graphql/containers';
import { BlurTextFieldType, IBlurTextFieldProps } from '../../components/connectedForm/BlurTextField/BlurTextField';
import { useFullUserDetails } from '../../utils/hooks';
import { HoldingMessage } from '../../components/FeatureFlag/HoldingMessage';
import { EdataHoldingInfo } from '../../components/FeatureFlag/EdataHoldingInfo';

const EdataConfigForm = ({ values }: { values: IEdataConfig }) => {
  const userDetails = useFullUserDetails();

  if (!userDetails?.flags?.edataEnabled) {
    return <HoldingMessage {...EdataHoldingInfo} />;
  }

  return (
    <Form.FormContainer>
      <Form.Header noDeleteOption={true} component={Form.HeaderBlock} />
      <Form.Form>
        <Form.Row>
          <Form.Fieldset cols={1 / 2}>
            <Form.Legend label="Credentials" />
            <Form.Field dataid="baseUrl" component={input.BlurTextField} label="Host" />
            <Form.Field dataid="clientId" component={input.BlurTextField} label="Username" />
            <Form.Field<IBlurTextFieldProps>
              dataid="clientSecret"
              component={input.BlurTextField}
              label="API Key"
              type={BlurTextFieldType.Password}
              placeholder={values?.clientSecretSet ? 'Type to overwrite' : undefined}
            />
            <Form.Field<IBlurTextFieldProps>
              dataid="guid"
              component={input.BlurTextField}
              label="GUID"
              placeholder={values?.clientSecretSet ? 'Type to overwrite' : undefined}
            />
          </Form.Fieldset>
        </Form.Row>
      </Form.Form>
    </Form.FormContainer>
  );
};

function submitValues(props: ComponentProps<typeof EdataConfigForm>) {
  const values = Object.assign({}, props.values);

  // read only fields
  delete values.clientSecretSet;
  return values;
}

export default compose(
  withContainer.formQuery(entity.instance),
  withContainer.defaultRecord(entity.default),
  withContainer.formMutation(entity.update),
  createForm({
    form: entity.type,
    name: entity.formTitle,
    entity: entity,
    queryFragment: entity.fragment,
    getSubmitValues: submitValues,
  })
)(EdataConfigForm);
